HeDisplayUtil = {
    hitTestPoint(node, worldPosition, useGroupTest, hitAreaNodeTag) {
        var rect = useGroupTest ? HeDisplayUtil.getNodeGroupBounds(node, null, hitAreaNodeTag) : HeDisplayUtil.getNodeBounds(node, null);
        return cc.rectContainsPoint(rect, worldPosition);
    },
    getNodeToWorldAffineTransform(node) {
        let t = node.getNodeToParentAffineTransform();
        for (var p = node.parent; p != null; p = p.getParent())
            t = cc.affineTransformConcat(t, p.getNodeToParentAffineTransform());
        return t;
    },
    getNodeBounds(node, rootNode) {
        var size = node.getContentSize();
        var bound = CCRectMake(0, 0, size.width, size.height);
        var transform = HeDisplayUtil.getNodeToWorldAffineTransform(node); //CCAffineTransform transform
        return cc.rectApplyAffineTransform(bound, transform);
    },
    getNodeGroupBounds(node, rootNode, hitAreaNodeTag) {
        if (hitAreaNodeTag != 0) {
            var hitAreaChild = node.getChildByTag(hitAreaNodeTag);
            if (hitAreaChild) {
                return HeDisplayUtil.getNodeBounds(hitAreaChild, rootNode);
            }
        }
        var numberOfChildren = node.childrenCount;
        var computedBounds = HeDisplayUtil.getNodeBounds(node, rootNode);
        if (numberOfChildren <= 0) {
            return computedBounds;
        } else {
            var minX = computedBounds.x;
            var minY = computedBounds.y;
            var maxX = minX + computedBounds.width;
            var maxY = minY + computedBounds.height;
            var children = node.getChildren();
            var childrenCount = children && children.length;
            if (childrenCount > 0) {
                let childs = node.getChildren()
                for (let index in childs) {
                    var pChild = childs[index];
                    if (pChild) {
                        var childBounds = HeDisplayUtil.getNodeGroupBounds(pChild, rootNode, hitAreaNodeTag);
                        var vx = childBounds.x;
                        var vy = childBounds.y;
                        var vw = vx + childBounds.width;
                        var vh = vy + childBounds.height;

                        if (vx < minX) minX = vx;
                        if (vy < minY) minY = vy;
                        if (vw > maxX) maxX = vw;
                        if (vh > maxY) maxY = vh;
                    }
                }
            }
            return CCRectMake(minX, minY, maxX - minX, maxY - minY);
        }
    }
}

HeDisplayUtil.urlDecode = function (str, defaultStr) {
    str = str || defaultStr || getText("clover.text.375")
    let decodedStr
    try {
        decodedStr = window.decodeURIComponent(str)
    } catch (error) {
        decodedStr = str
    }
    return decodedStr
}
HeDisplayUtil.urlEncode = function (str) {
    str = str || ""
    let encodedStr
    try {
        encodedStr = window.encodeURIComponent(str)
    } catch (error) {
        encodedStr = str
    }
    return encodedStr
}

HeDisplayUtil.ccc3FromUInt = function (bytes) {
    let r	= bytes >> 16 & 0xFF;
    let g	= bytes >> 8 & 0xFF;
    let b	= bytes & 0xFF;
    return cc.color(r, g, b);
}

HeBezierTo = cc.BezierTo.extend({
    initWithDuration(t, to, direction, offset) {
        let bRet = false

        if (this._super(t)) {
            this.to = to
            this.direction = direction
            this.offset = offset
        }

        return bRet
    },

    startWithTarget(pTarget) {
        cc.BezierBy.prototype.startWithTarget.call(this, pTarget)
        let from = pTarget.getPosition()
        let lineLength = Math.sqrt(Math.pow(this.to.x - from.x, 2) + Math.pow(this.to.y - from.y, 2))
        let ang1 = Math.atan2(this.offset, lineLength / 2)
        let ang2 = Math.PI / 2 - 2 * ang1
        let tempTarX1 = this.offset * Math.tan(ang2)
        let tempTarY1 = this.direction ? this.offset : -this.offset
        let tempTarX2 = lineLength - tempTarX1
        let tempTarY2 = tempTarY1

        let rotateAng = Math.atan2(this.to.y - from.y, this.to.x - from.x)
        let cosVal = Math.cos(rotateAng)
        let sinVal = Math.sin(rotateAng)

        let tarX1 = cosVal * tempTarX1 - sinVal * tempTarY1
        let tarY1 = sinVal * tempTarX1 + cosVal * tempTarY1
        let tarX2 = cosVal * tempTarX2 - sinVal * tempTarY2
        let tarY2 = sinVal * tempTarX2 + cosVal * tempTarY2

        let endPoint = cc.p(this.to.x - from.x, this.to.y - from.y)

        this._config[0] = cc.p(tarX1, tarY1)
        this._config[1] = cc.p(tarX2, tarY2)
        this._config[2] = endPoint
    }
})

HeBezierTo.create = function (t, to, direction, offset) {
    let pBezierTo = new HeBezierTo()
    pBezierTo.initWithDuration(t, to, direction, offset)

    return pBezierTo
}

HeContentSizeTo = cc.ActionInterval.extend({
    initWithDuration(t, to) {
        let ret = false

        if (this._super(t)) {
            this.to = to
        }

        return ret
    },

    startWithTarget(pTarget) {
        this.from = pTarget.getContentSize()
        this._super(pTarget)
    },

    update(time) {
        let width = this.from.width + (this.to.width - this.from.width) * time;
        let height = this.from.height + (this.to.height - this.from.height) * time;

        if (this.target)
            this.target.setContentSize(width, height)
    }
})

HeContentSizeTo.create = function(t, to) {
    let ret = new HeContentSizeTo()
    ret.initWithDuration(t, to)
    return ret
}

exports.HeDisplayUtil = HeDisplayUtil
exports.HeBezierTo = HeBezierTo
exports.HeContentSizeTo = HeContentSizeTo
